/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-datatable-scrollable{display:flex;flex-direction:column}  .ui-datatable-scrollable-wrapper{flex:1 1 0}  .ui-datatable-scrollable-view{height:100%;display:flex;flex-direction:column}  .ui-datatable-scrollable-body{flex:1 1 0;overflow-y:scroll}  .select-multiple-header{display:block;margin-bottom:-14px}  .synced-row{float:right}"];
export { styles as styles };
